import { Typography } from '@mui/material'
import { DetailsPreviousPendingRequest } from '../../ReceivementTypes'
import { useMemo } from 'react'
import { limitCharacters } from 'src/utils/formatString'
import { SwapOrReturnTypeIds, SwapOrReturnTypesEnum } from 'src/features/swap-or-return/SwapOrReturnTypes'
import Modal from 'src/components/Modal'
import TableMui from 'src/components/TableMui'
import * as S from './PreviousPendingRequestDetailsModal.styles'

interface PreviousPendingRequestDetailsModalProps {
  show: boolean
  details: DetailsPreviousPendingRequest[]
  invoiceNumber: number
  requestTypeId: number
  setOpenDetailsModal: React.Dispatch<React.SetStateAction<boolean>>
}

const PreviousPendingRequestDetailsModal: React.FC<PreviousPendingRequestDetailsModalProps> = ({
  show, details, invoiceNumber, requestTypeId, setOpenDetailsModal,
}) => {
  const limitNumberCharacters = 38

  const rows = useMemo(() => details.map((item) => ({
    ...item,
    productDescription: (
      <Typography fontSize={14}>
        {limitCharacters(item.productDescription, limitNumberCharacters)}
      </Typography>
    ),
  })), [details])

  const requestType = requestTypeId === SwapOrReturnTypeIds.RETURN ? SwapOrReturnTypesEnum.RETURN : SwapOrReturnTypesEnum.SWAP

  return (
    <Modal
      show={show}
      title={`Detalhes pendência NF ${invoiceNumber}`}
      centered
      size='lg'
      closeButtonAction={() => setOpenDetailsModal(false)}
      testId='previous-pending-request-details-modal-test-id'
      body={(
        <S.ContainerTable>
          <Typography><strong>Tipo:</strong> {requestType.toLowerCase()}
          </Typography>
          <TableMui
            columns={[
              { id: 'productCode', label: 'Cód. produto' },
              { id: 'productDescription', label: 'Desc. produto' },
              { id: 'returnQuantity', label: 'Qtd. a devolver' },
            ]}
            flatTable
            thinLine
            rows={rows}
            enablePagination={false}
            maxHeight='40vh'
            testId='previous-pending-request-details-table-test-id'
          />
        </S.ContainerTable>
      )}
    />
  )
}

export default PreviousPendingRequestDetailsModal
